import * as turf from "@turf/turf"

// Azimuth 0..360, null for an unchanged position; only "greatcircle" is a great circle (as in RouteAnalyser2).
export function courseBearing(a, b, legtype) {
  if (a[0] === b[0] && a[1] === b[1]) return null
  const bearing = legtype === "greatcircle" ? turf.bearing(a, b) : turf.rhumbBearing(a, b)
  return turf.bearingToAzimuth(bearing)
}

// Raw DB track features lack course_bearing; the selector adds it for store routes.
export function stampCourseBearing(features) {
  return features.map((f, i) => {
    const a = f.geometry?.coordinates
    const b = features[i + 1]?.geometry?.coordinates
    const course = a && b ? courseBearing(a, b, f.properties?.legtype) : null
    return { ...f, properties: { ...f.properties, course_bearing: course } }
  })
}
